import React, { Component } from 'react'
import { connect } from 'react-redux'
import { PLANN3R_COLOR } from '../../../constants'

import './../Tabs/Editor/Editor.scss'
import './Preview.scss'

class Preview extends Component {
  constructor(props) {
    super(props)

    if (this.props.location.my_office.enabled) {
      this.state = {
        selectedLocationTab: 'MY_OFFICE',
        selectedLocation: this.props.location.my_office.locations[0],
      }
    } else if (this.props.location.call.enabled) {
      this.state = {
        selectedLocationTab: 'CALL',
        selectedLocation:
          this.props.location.call.options[0].type +
          ' - ' +
          this.props.location.call.options[0].value,
      }
    } else if (this.props.location.their_office.enabled) {
      this.state = {
        selectedLocationTab: 'THEIR_OFFICE',
        selectedLocation: '',
      }
    }
  }

  componentDidUpdate() {
    const { location } = this.props
    if (
      !location.my_office.enabled &&
      !location.their_office.enabled &&
      location.call.enabled
    ) {
      if (this.state.selectedLocationTab !== 'CALL') {
        this.setState({
          selectedLocationTab: 'CALL',
          selectedLocation: this.props.location.my_office.locations[0],
        })
      }
    }

    if (
      location.my_office.enabled &&
      !location.their_office.enabled &&
      !location.call.enabled
    ) {
      if (this.state.selectedLocationTab !== 'MY_OFFICE') {
        this.setState({
          selectedLocationTab: 'MY_OFFICE',
          selectedLocation:
            this.props.location.call.options[0].type +
            ' - ' +
            this.props.location.call.options[0].value,
        })
      }
    }

    if (
      !location.my_office.enabled &&
      location.their_office.enabled &&
      !location.call.enabled
    ) {
      if (this.state.selectedLocationTab !== 'THEIR_OFFICE') {
        this.setState({
          selectedLocationTab: 'THEIR_OFFICE',
          selectedLocation: '',
        })
      }
    }
  }

  renderDuration(field) {
    const fieldStyle = {
      color: this.props.colors.primary ? this.props.colors.primary : '#10365D',
    }

    const { strings } = this.props

    return (
      <div key={field.id} className="page_field">
        <label style={fieldStyle}>{strings.duration}</label>
        <div>
          {field.durations.map((duration, index) => {
            return (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  margin: '10px 0px',
                  cursor: 'pointer',
                }}
                key={index}
              >
                <div
                  className={
                    parseInt(duration.duration, 10) === this.props.duration
                      ? 'radio selected'
                      : 'radio'
                  }
                  style={{
                    marginRight: '10px',
                    borderColor:
                      parseInt(duration.duration, 10) === this.props.duration &&
                      this.props.colors.secondary
                        ? this.props.colors.secondary
                        : PLANN3R_COLOR,
                  }}
                >
                  <div
                    className="inner_radio"
                    style={{
                      backgroundColor: this.props.colors.secondary
                        ? this.props.colors.secondary
                        : PLANN3R_COLOR,
                    }}
                  />
                </div>
                <span
                  style={{
                    color:
                      parseInt(duration.duration, 10) === this.props.duration &&
                      this.props.colors.secondary
                        ? this.props.colors.secondary
                        : PLANN3R_COLOR,
                    fontWeight:
                      parseInt(duration.duration, 10) === this.props.duration
                        ? 'bolder'
                        : '',
                  }}
                >
                  {duration.label + ' - (' + duration.duration + ' min)'}
                </span>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  renderField(field) {
    if (field.type === 'text') {
      return this.renderText(field)
    }

    if (field.type === 'email' || field.type === 'name') {
      return this.renderText(field)
    }

    if (field.type === 'location') {
      return this.renderLocation(field)
    }

    if (field.type === 'duration') {
      return this.renderDuration(field)
    }

    return <div />
  }

  renderFields() {
    const fields = this.props.fields.map(this.renderField, this)
    return <div>{fields}</div>
  }

  renderLocation(field) {
    const fieldStyle = {
      color: this.props.colors.primary ? this.props.colors.primary : '#10365D',
    }

    const { strings } = this.props

    const location = this.props.location

    const normal_tab = {
      borderColor: this.props.colors.secondary,
      backgroundColor: 'white',
      color: this.props.colors.secondary,
    }

    const selected_tab = {
      borderColor: this.props.colors.secondary,
      backgroundColor: this.props.colors.secondary,
      color: 'white',
    }

    const normal_item = {
      color: '#10365D',
    }

    const selected_item = {
      color: this.props.colors.secondary,
    }

    return (
      <div key={field.id} className="page_field">
        {(location.my_office.enabled || location.their_office.enabled) && (
          <label style={fieldStyle}>
            {strings.location}
            {field.required && <sup>*</sup>}
          </label>
        )}
        <div className="location_field">
          <div className="location_tab">
            {location.my_office.enabled && (
              <span
                className={
                  this.state.selectedLocationTab === 'MY_OFFICE'
                    ? 'selected'
                    : ''
                }
                style={
                  this.state.selectedLocationTab === 'MY_OFFICE'
                    ? selected_tab
                    : normal_tab
                }
                onClick={() => {
                  this.setState({
                    selectedLocationTab: 'MY_OFFICE',
                    selectedLocation: location.my_office.locations[0],
                  })
                }}
                role="presentation"
              >
                {strings.my_office}
              </span>
            )}
            {location.call.enabled && (
              <span
                className={
                  this.state.selectedLocationTab === 'CALL' ? 'selected' : ''
                }
                style={
                  this.state.selectedLocationTab === 'CALL'
                    ? selected_tab
                    : normal_tab
                }
                onClick={() => {
                  this.setState({
                    selectedLocationTab: 'CALL',
                    selectedLocation:
                      location.call.options[0].type +
                      ' - ' +
                      location.call.options[0].value,
                  })
                }}
                role="presentation"
              >
                {strings.call}
              </span>
            )}
            {location.their_office.enabled && (
              <span
                className={
                  this.state.selectedLocationTab === 'THEIR_OFFICE'
                    ? 'selected'
                    : ''
                }
                style={
                  this.state.selectedLocationTab === 'THEIR_OFFICE'
                    ? selected_tab
                    : normal_tab
                }
                onClick={() => {
                  this.setState({
                    selectedLocationTab: 'THEIR_OFFICE',
                    selectedLocation: '',
                  })
                }}
                role="presentation"
              >
                {strings.your_office}
              </span>
            )}
          </div>
          <div className="location_content">
            {this.state.selectedLocationTab === 'MY_OFFICE' && (
              <ul>
                {location.my_office.locations.map((location) => {
                  const selected = this.state.selectedLocation === location
                  return (
                    <li
                      key={location}
                      className={selected ? 'selected' : ''}
                      style={selected ? selected_item : normal_item}
                      onClick={() => {
                        this.setState({ selectedLocation: location })
                      }}
                      role="presentation"
                    >
                      <i className="fa fa-map-marker" />
                      {location}
                    </li>
                  )
                })}
              </ul>
            )}
            {this.state.selectedLocationTab === 'CALL' && (
              <ul>
                {location.call.options.map((option) => {
                  const selected =
                    this.state.selectedLocation ===
                    option.type + ' - ' + option.value
                  return (
                    <li
                      key={option.type + ' - ' + option.value}
                      className={selected ? 'selected' : ''}
                      style={selected ? selected_item : normal_item}
                      onClick={() => {
                        this.setState({
                          selectedLocation: option.type + ' - ' + option.value,
                        })
                      }}
                      role="presentation"
                    >
                      <i className="fa fa-phone" />
                      {option.type + ' - ' + option.value}
                    </li>
                  )
                })}
              </ul>
            )}
            {this.state.selectedLocationTab === 'THEIR_OFFICE' && (
              <div className="full-width">
                <input
                  type="text"
                  className="full-width"
                  placeholder={strings.fill_in_address}
                  value={this.state.selectedLocation}
                  onChange={(e) => {
                    this.setState({ selectedLocation: e.target.value })
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }

  renderText(field) {
    const fieldStyle = {
      color: this.props.colors.primary ? this.props.colors.primary : '#10365D',
    }

    return (
      <div key={field.id} className="page_field">
        <label style={fieldStyle}>
          {field.label}
          {field.required && <sup>*</sup>}
        </label>
        <div className="field">
          <input
            className="input"
            type="text"
            value={field.value}
            placeholder={field.placeholder}
            id={field.id}
            readOnly
          />
        </div>
      </div>
    )
  }

  render() {
    const strings = this.props.strings
    if (this.props.isFetching) {
      return (
        <div>
          <p>Fetching</p>
        </div>
      )
    }

    const fieldStyle = {
      color: this.props.colors.primary ? this.props.colors.primary : '#10365D',
    }

    return (
      <div className="grey round-corners page preview" style={fieldStyle}>
        <div className="has-text-centered">
          <span className="preview_label">{strings.preview}</span>
          <img
            src={this.props.logo}
            alt={this.props.display_name}
            className="logoCompanyPage"
          />
          {this.props.copy.tag_line && (
            <p
              style={{
                marginBottom: '0px',
                fontSize: '1.4rem',
                color: this.props.colors.primary
                  ? this.props.colors.primary
                  : '#10365D',
              }}
            >
              {this.props.copy.tag_line}
            </p>
          )}
          {(!this.props.copy.tag_line || this.props.tag_line === '') && (
            <p
              style={{
                marginBottom: '0px',
                fontSize: '1.4rem',
                color: this.props.colors.primary
                  ? this.props.colors.primary
                  : '#10365D',
              }}
            >
              {strings.meeting_schedule}
              <b
                style={{
                  color: this.props.colors.secondary,
                  fontWeight: 'bold',
                }}
              >
                {this.props.display_name}
              </b>
            </p>
          )}
        </div>
        {this.renderFields()}

        <div className="has-text-centered">
          <button
            className="button is-primary acceptButton"
            style={{ backgroundColor: this.props.colors.secondary }}
          >
            {this.props.copy.button}
          </button>

          <span className="required">{strings.required}</span>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const page =
    state.pagesManagement.active_company && state.pagesManagement.active_page
      ? state.pagesManagement.companies
        .find(
          (company) => company.id === state.pagesManagement.active_company,
        )
        .pages.find((page) => page.id === state.pagesManagement.active_page)
      : null

  return {
    strings: state.languages.strings.pages.preview,
    company: state.pagesManagement.companies.find(
      (company) => company.id === state.pagesManagement.active_company,
    ),
    logo: page
      ? page.avatar
      : 'https://s3-us-west-2.amazonaws.com/plann3r.profilepictures/default.png',
    copy: page ? page.copy : null,
    display_name: page ? page.display_name : null,
    colors: page ? page.colors : null,
    location: page ? page.location : null,
    fields: page ? page.fields : null,
    isFetching: state.pagesManagement.isFetching,
  }
}

export default connect(mapStateToProps)(Preview)
